module.exports = __webpack_public_path__ + "68c525e439c69ba917129098fdf82ff4.pdf";